define('app/factories/lazy_factory',['app/setup', 'app/views/lazy_view'], function(takhfifan, lazyView) {
  $(function($) {
    if ($('img.lazy').length > 0) {
      // var $window = new takhfifan.WindowView({
      //   el: $(window)
      // });

      $('.wrapper').each(function() {
        new takhfifan.LazyView({
          el: $(this)
        });
      });
    }
  });
});

